import React from "react";
import ChaletSearchResultSlider from "./refiners/ChaletSearchResultsSlider";
import ChaletRatingComponent from "./refiners/ChaletSearchRatingComponent";
import ChaletSearchCheckboxList from "./refiners/ChaletSearchCheckboxList";

import {
  SliderSettings,
  RatingSettings,
  CheckboxListSettings,
} from "@/types/refiners";

interface ChaletSearchResultRefinersProps {
  priceSliderSettings: SliderSettings;
  distanceResortCentreSliderSettings: SliderSettings;
  distanceSkiLiftliderSettings: SliderSettings;
  propertyRatingSettings: RatingSettings;
  resortCheckListSettings: CheckboxListSettings;
  inspireMeAttributeCheckboxListSettings: CheckboxListSettings;
  accommodationTypeCheckboxListSettings: CheckboxListSettings;
}

function ChaletSearchResultRefiners({
  priceSliderSettings,
  distanceResortCentreSliderSettings,
  distanceSkiLiftliderSettings,
  propertyRatingSettings,
  resortCheckListSettings,
}: ChaletSearchResultRefinersProps) {
  const showInspireMeAndResortRefiners =
    resortCheckListSettings.items.length >= 2;

  return (
    <div className="sidebar">
      <h3>Filters</h3>
      <div className="refiner-section">
        <ChaletSearchResultSlider
          title="Price"
          min={priceSliderSettings.min}
          max={priceSliderSettings.max}
          step={priceSliderSettings.step}
          defaultValue={priceSliderSettings.defaultValue}
          onChange={priceSliderSettings.onChange}
          marks={priceSliderSettings.marks}
          numberType="money"
        />
      </div>
      <div className="refiner-divider"></div>
      <div className="refiner-section">
        <ChaletSearchResultSlider
          title={distanceResortCentreSliderSettings.title}
          min={distanceResortCentreSliderSettings.min}
          max={distanceResortCentreSliderSettings.max}
          step={distanceResortCentreSliderSettings.step}
          defaultValue={distanceResortCentreSliderSettings.defaultValue}
          onChange={distanceResortCentreSliderSettings.onChange}
          marks={distanceResortCentreSliderSettings.marks}
          numberType="distance"
        />
      </div>
      <div className="refiner-divider"></div>
      <div className="refiner-section">
        <ChaletSearchResultSlider
          title={distanceSkiLiftliderSettings.title}
          min={distanceSkiLiftliderSettings.min}
          max={distanceSkiLiftliderSettings.max}
          step={distanceSkiLiftliderSettings.step}
          defaultValue={distanceSkiLiftliderSettings.defaultValue}
          onChange={distanceSkiLiftliderSettings.onChange}
          marks={distanceSkiLiftliderSettings.marks}
          numberType="distance"
        />
      </div>
      <div className="refiner-divider"></div>
      <div className="refiner-section">
        <ChaletRatingComponent
          name={propertyRatingSettings.name}
          defaultValue={propertyRatingSettings.defaultValue}
          onChange={propertyRatingSettings.onChange}
          // min={distanceSkiLiftliderSettings.min}
          // max={distanceSkiLiftliderSettings.max}
        />
      </div>
      <div className="refiner-divider"></div>
      <div className="refiner-section">
        {/* <AccommodationTypeCheckboxList
          items={accommodationTypeCheckboxListSettings.items}
          onChange={accommodationTypeCheckboxListSettings.onSelectionChange}
          title={accommodationTypeCheckboxListSettings.title}
        /> */}
      </div>

      {showInspireMeAndResortRefiners && (
        <>
          <div className="refiner-divider"></div>
          <div className="refiner-section">
            <ChaletSearchCheckboxList
              items={resortCheckListSettings.items}
              onChange={resortCheckListSettings.onSelectionChange}
            />
          </div>
          <div className="refiner-divider"></div>
          <div className="refiner-section">
            {/* <InspireMeAttributeCheckboxList
              items={inspireMeAttributeCheckboxListSettings.items}
              onChange={
                inspireMeAttributeCheckboxListSettings.onSelectionChange
              }
            /> */}
          </div>
        </>
      )}
    </div>
  );
}

export default ChaletSearchResultRefiners;
